import { combineReducers } from 'redux';

import EventHandler from './Event/EventReducer';
import SessionHandler from './Session/SessionReducer';

const FormSwiftAPIHandler = combineReducers({
  EventHandler,
  SessionHandler,
});

export default FormSwiftAPIHandler;



// WEBPACK FOOTER //
// ./src-react/FormSwiftAPI/FormSwiftAPIReducer.jsx